import { ChangeDetectorRef, Component, effect, inject, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { interval, Subscription } from 'rxjs';
import { LimitExceededEvent } from '../../models/LimitExceededEvent';
import { LimitsService } from '../../services/limits.service';
import { LimitExceededDialogComponent } from '../limit-exceeded-dialog/limit-exceeded-dialog.component';
import { MaterialModule } from '../../material.module';

@Component({
    selector: 'app-limit-alert',
    templateUrl: './limit-alert.component.html',
    styleUrls: ['./limit-alert.component.scss'],
    imports: [MaterialModule]
})
export class LimitAlertComponent {

  private shakeSub?: Subscription;
  readonly limitsExceeded = signal(false);

  withShake = false;

  private event: LimitExceededEvent | null = null;

  private dialog = inject(MatDialog);
  private limitsService = inject(LimitsService);
  private cdr = inject(ChangeDetectorRef);

  constructor() {
    effect(() => {
      const exc = this.limitsService.limitsExceeded();
      if (exc) {
        this.limitsExceeded.set(true);
        this.event = exc;
        this.startShaking();
      }
    });

  }

  ngOnDestroy() {
  }


  showLimits() {
    this.limitsExceeded.set(false);
    this.stopShaking();

    const dlg = this.dialog.open(LimitExceededDialogComponent, {
      data: this.event,
      width: '30%'
    });
  }

  private startShaking() {
    if (!this.shakeSub) {
      this.shakeSub =
        interval(1500)
          .subscribe(() => {
            this.withShake = !this.withShake;
            this.cdr.markForCheck();
          });
    }
  }

  private stopShaking() {
    if (this.shakeSub) {
      this.shakeSub.remove(this.shakeSub);
      this.shakeSub.unsubscribe();
      this.shakeSub = undefined;
    }
  }

}
